/* Card Components */
.card {
    background-color: var(--bg-secondary);
    border-radius: var(--radius-lg);
    box-shadow: var(--shadow);
    padding: clamp(var(--space-4), 5vw, var(--space-5));
    transition: all 0.3s ease;
    border: 1px solid var(--gray-300);
    margin-bottom: var(--space-4);
  }
  
  .card:hover {
    box-shadow: var(--shadow-glow);
  }
  
  /* Header Components */
  .pageHeader {
    background-color: var(--bg-secondary);
    color: var(--text-primary);
    padding: var(--space-6) 0;
    margin-bottom: var(--space-5);
    border-bottom: 1px solid var(--gray-700);
  }
  
  .headerContent {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 var(--space-4);
  }
  
  .headerRow {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: var(--space-3);
  }
  
  /* Button Styles */
  .primaryButton {
    background-color: var(--primary);
    color: var(--bg-primary);
    border: none;
    padding: var(--space-3) var(--space-4);
    border-radius: var(--radius);
    font-size: 16px;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: var(--space-2);
    cursor: pointer;
    transition: all 0.2s ease;
  }
  
  .primaryButton:hover {
    background-color: var(--primary-dark);
    transform: translateY(-2px);
  }
  
  .secondaryButton {
    background-color: var(--bg-tertiary);
    color: var(--text-primary);
    border: 1px solid var(--gray-700);
    padding: var(--space-3) var(--space-4);
    border-radius: var(--radius);
    font-size: 16px;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: var(--space-2);
    cursor: pointer;
    transition: all 0.2s ease;
  }
  
  .secondaryButton:hover {
    background-color: var(--bg-elevated);
    transform: translateY(-2px);
  }
  
  /* Container layouts */
  .pageContainer {
    min-height: 100vh;
    background-color: var(--bg-primary);
    display: flex;
    flex-direction: column;
  }
  
  .contentContainer {
    padding: var(--space-5);
    max-width: 1200px;
    margin: 0 auto;
    width: 100%;
  }

  /* Responsive grid system */
  .gridContainer {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(min(100%, 350px), 1fr));
    gap: var(--space-4);
  }

  @media (max-width: 768px) {
    .headerRow {
      flex-direction: column;
      align-items: flex-start;
      gap: var(--space-3);
    }
  
    .secondaryButton {
      width: 100%;
      justify-content: center;
      margin-top: var(--space-2);
    }
    
    .pageHeader {
      padding: var(--space-4) 0;
    }
    
    .contentContainer {
      padding: var(--space-4) var(--space-3);
    }
  }
  
  @media (max-width: 480px) {
    .gridContainer {
      grid-template-columns: 1fr;
    }
    
    .primaryButton, .secondaryButton {
      padding: var(--space-3) var(--space-3);
      font-size: 14px;
    }
  }